import React, { useEffect, useState } from 'react';
import './Usuarios.css';

import { Button, Box, IconButton, FormControl, InputLabel, Select, MenuItem, Paper, Typography, Divider } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import Loading from '../../components/loading/Loading';
import { UserInfo } from '../../dto/UserInfo';
import PersonRoundedIcon from '@mui/icons-material/PersonRounded';
import { mostraMensagemErro } from '../../helpers/Notificacoes';
import SearchIcon from '@mui/icons-material/Search';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import Paginacao from '../../components/paginacao/paginacao';
import { formataFiltrosBusca } from '../../helpers/ValidaAgente';
import MyTextField, { MaskType } from '../../components/inputs/inputBusca';
import { UsuarioServices } from '../../services/UsuarioService';
import { Usuario } from '../../dto/Usuario';
import CustomTableSelectEmpresas from '../../components/customTableSelectEmpresas/customTableSelectEmpresas';
import CustomTableSelectUsuarios from '../../components/customTableSelectUsuarios/CustomTableSelectUsuarios';

function UsuarioModule() {
    const navigate = useNavigate();
    const userInfo: UserInfo = JSON.parse(localStorage.getItem('udbs')!);

    const [usuarios, setUsuarios] = useState([]);
    const [buscouUsuarios, setBuscouUsuarios] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [pageSize] = useState(15);
    const [totalRegistros, setTotalRegistros] = useState(0);
    const arrayColunas: string[] = ['codAgente', 'nome', 'email', 'nomeEmpresa', 'ativo'];
    const [colunaFilter, setColunaFilter] = useState<string | null>(null);
    const [colunas, setColunas] = useState<string[]>(arrayColunas);
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredUsuarios, setFilteredUsuarios] = useState([]);
    const [erro, setErro] = useState('');

    const usuarioService = new UsuarioServices()

    useEffect(() => {
        if (erro !== "") {
            mostraMensagemErro(erro);
        }
    }, [erro]);

    useEffect(() => {
        if (searchTerm.trim() === '' || !buscouUsuarios) {
            buscaUsuarios();
        }
    }, [searchTerm]);


    useEffect(() => {
        if (searchTerm.trim() === '') {
            setFilteredUsuarios(usuarios);
            setTotalRegistros(usuarios.length)
        }
    }, [searchTerm, usuarios]);


    async function buscaUsuarios() {
        setIsLoading(true);

        const response = await usuarioService.get(`/v1/usuarios`);
        if (response.codigo !== 200) {
            if (response.codigo === 404) {
                setBuscouUsuarios(true);
                setErro('Não há registros');
            } else {
                setErro(response.mensagem);
            }

            setIsLoading(false);
        } else {
            setErro('');
            setUsuarios(response.status ?? []);
            setFilteredUsuarios(response.status ?? []);
            setTotalRegistros(response.status.total);
            setIsLoading(false);
            setBuscouUsuarios(true);
        }
    }


    const handlePageChange = (event: React.ChangeEvent<unknown>, value: number) => {
        setPage(value);
    };

    const handleBuscarComFiltro = async () => {
        await buscaUsuariosFiltro();
        setPage(1);
    };

    async function buscaUsuariosFiltro() {
        let valorFiltro = searchTerm;

        if (searchTerm === "ATIVO") {
            valorFiltro = "true";
        } else if (searchTerm === "INATIVO") {
            valorFiltro = "false";
        }

        const response = await usuarioService.get(`/v1/usuarios?${colunaFilter}=${valorFiltro}`);
        if (response.codigo !== 200) {
            if (response.codigo === 404) {
                setBuscouUsuarios(true);
                setErro('Não há registros');
            } else {
                setErro(response.mensagem);
            }

            setIsLoading(false);
        } else {
            setErro('');
            setUsuarios(response.status ?? []);
            setFilteredUsuarios(response.status ?? []);
            setTotalRegistros(response.status.total);
            setIsLoading(false);
            setBuscouUsuarios(true);
        }
    }

    const dadosPaginados = filteredUsuarios.slice(
        (page - 1) * pageSize,
        page * pageSize
    );

    const novoUsuario = () => {
        navigate("/mvp", {
            state: {
                propsPage: "cadUsuario"
            }
        })
    }

    async function editarUsuario(usuario: Usuario) {
        navigate("/mvp", {
            state: {
                usuario,
                propsPage: "editarUsuario"
            }
        })
    }

    async function handleVisualizarUsuario(usuario: Usuario) {
        await navigate("/mvp", {
            state: {
                usuario,
                propsPage: "visualizarUsuario"
            }
        })
    }

    return (
        <div className="Home">
            {isLoading && <Loading />}
            <Paper elevation={0} className='usuarios-paper-header'>
                <Box className='usuarios-header-top'>
                    <Box className='usuarios-title-wrap'>
                        <Box className='usuarios-title-icon'>
                            <PersonRoundedIcon />
                        </Box>
                        <Box>
                            <Box className='usuarios-title-line'>
                                <Typography variant='h6' className='usuarios-title'>
                                    Usuários Cadastrados
                                </Typography>
                            </Box>
                            <Typography className='usuarios-subtitle'>
                                Acompanhe os usuários cadastrados e suas informações detalhadas.
                            </Typography>
                        </Box>
                    </Box>
                    <Divider className='usuarios-divider' />
                </Box>
                <Button
                    className='usuarios-btn-novo'
                    variant='contained'
                    onClick={novoUsuario}
                >
                    Novo usuário
                </Button>
                <Box className='usuarios-filtros-row'>
                    <FormControl size='small' className='usuarios-form-control'>
                        <InputLabel shrink>Filtrar por</InputLabel>
                        <Select
                            value={colunaFilter}
                            onChange={(e: any) => {
                                setColunaFilter(e.target.value);
                                setSearchTerm("");
                            }}
                            label='Filtrar por'
                            displayEmpty
                        >
                            {colunas.map((item) => (
                                <MenuItem key={item} value={item} sx={{ fontSize: '14px' }}>
                                    {item === 'codAgente' ? 'Código Agente' :
                                        item === 'nome' ? 'Nome' :
                                            item === 'email' ? 'Email' :
                                                item === 'nomeEmpresa' ? 'Nome Empresa' :
                                                    item === 'ativo' ? 'Ativo' :
                                                        item.charAt(0).toUpperCase() + item.slice(1)}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <Box className="usuarios-search-box">
                        <MyTextField
                            tipo={colunaFilter as MaskType}
                            value={searchTerm}
                            onValueChange={setSearchTerm}
                            onClear={() => {
                                setSearchTerm("");
                                setFilteredUsuarios(usuarios);
                                setColunaFilter(null);
                            }}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    handleBuscarComFiltro();
                                }
                            }}
                        >
                        </MyTextField>
                    </Box>

                    <IconButton
                        aria-label="Pesquisar"
                        className='usuarios-btn-buscar'
                        onClick={handleBuscarComFiltro}
                        disabled={searchTerm === "" && colunaFilter !== "dataLancamento"}
                    >
                        {searchTerm !== "" || colunaFilter === "dataLancamento" ? <SearchIcon /> : <SearchOffIcon />}
                    </IconButton>

                    <button
                        className='usuarios-limpar'
                        onClick={() => {
                            setSearchTerm("");
                            setFilteredUsuarios(usuarios);
                            setColunaFilter(null);
                        }}
                    >
                        Limpar filtros
                    </button>
                </Box>
            </Paper>
            <div className='ContainerListaUsuarios'>
                 <CustomTableSelectUsuarios
                    data={dadosPaginados}
                    buscouUsuarios={buscouUsuarios}
                    handleSetUsuario={novoUsuario}
                    handleEditarUsuario={editarUsuario}
                    handleVisualizarUsuario={handleVisualizarUsuario}
                    editavel={true}
                />

                <div className="PaginationContainer">
                    <Paginacao
                        totalRegistros={totalRegistros}
                        paginaAtual={page}
                        porPagina={pageSize}
                        aoMudarPagina={handlePageChange}
                    />
                </div>
            </div>
            <ToastContainer />
        </div>
    


       /*  <div className="Home">
            {isLoading && <Loading />}
                <Paper elevation={0} className='usuarios-paper-header'  sx={{ borderRadius: '4px', border: '1px solid #d9e5ee', padding: 2, width: '200%' }} >
                <Box className='usuarios-header-top'>
                    <Box className='usuarios-title-wrap'>
                        <Box className='usuarios-title-icon'>
                            <PersonRoundedIcon />
                        </Box>
                        <Box>
                            <Box className='usuarios-title-line'>
                                <Typography variant='h6' className='usuarios-title'>
                                    Usuários Cadastrados
                                </Typography>
                            </Box>
                            <Typography className='usuarios-subtitle'>
                                Acompanhe os usuários cadastrados e suas informações detalhadas.
                            </Typography>
                        </Box>
                    </Box>
                    <Divider className='usuarios-divider' />
                </Box>
                <Button
                    className='usuarios-btn-novo'
                    variant='contained'
                    onClick={novoUsuario}
                >
                    Novo usuário
                </Button>
                <Box className='usuarios-filtros-row'>
                    <FormControl size='small' className='usuarios-form-control'>
                        <InputLabel shrink>Filtrar por</InputLabel>
                        <Select
                            value={colunaFilter}
                            onChange={(e: any) => {
                                setColunaFilter(e.target.value);
                                setSearchTerm("");
                            }}
                            label='Filtrar por'
                            displayEmpty
                        >
                            {colunas.map((item) => (
                                <MenuItem key={item} value={item} sx={{ fontSize: '14px' }}>
                                    {item === 'codAgente' ? 'Código Agente' :
                                        item === 'nome' ? 'Nome' :
                                            item === 'email' ? 'Email' :
                                                item === 'nomeEmpresa' ? 'Nome Empresa' :
                                                    item === 'ativo' ? 'Ativo' :
                                                        item.charAt(0).toUpperCase() + item.slice(1)}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <Box className="usuarios-search-box">
                        <MyTextField
                            tipo={colunaFilter as MaskType}
                            value={searchTerm}
                            onValueChange={setSearchTerm}
                            onClear={() => {
                                setSearchTerm("");
                                setFilteredUsuarios(usuarios);
                                setColunaFilter(null);
                            }}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    handleBuscarComFiltro();
                                }
                            }}
                        />
                    </Box>
                    <IconButton
                        aria-label="Pesquisar"
                        className='usuarios-btn-buscar'
                        onClick={handleBuscarComFiltro}
                        disabled={searchTerm === ""}
                    >
                        {searchTerm !== "" ? <SearchIcon /> : <SearchOffIcon />}
                    </IconButton>
                    <button
                        className='usuarios-limpar'
                        onClick={() => {
                            setSearchTerm("");
                            setFilteredUsuarios(usuarios);
                            setColunaFilter(null);
                        }}
                    >
                        Limpar filtros
                    </button>
                </Box>
            </Paper>
            
            <div className='ContainerListaUsuarios'>
                <CustomTableSelectUsuarios
                    data={dadosPaginados}
                    buscouUsuarios={buscouUsuarios}
                    handleSetUsuario={novoUsuario}
                    handleEditarUsuario={editarUsuario}
                    handleVisualizarUsuario={handleVisualizarUsuario}
                    editavel={true}
                />
                <div className="PaginationContainer" style={{ marginTop: 16, display: 'flex', justifyContent: 'center' }}>
                    <Paginacao
                        totalRegistros={totalRegistros}
                        paginaAtual={page}
                        porPagina={pageSize}
                        aoMudarPagina={handlePageChange}
                    />
                </div>
            </div>
            <ToastContainer />
        </div> */
    );
}

export default UsuarioModule;
